import { useIsUngated } from './useIsUngated';
import { gate } from 'hub-http/gates';
export const useIsUngatedForBreeze = () => {
  return useIsUngated(gate('BreezeAI:Rebranding'));
};